
//FireBase setup - your Firebase details go here.
exports.firebaseConfig = {
  // apiKey: "AIzaSyB3lOGGll1djQ0S8V2UHUIzgS58ylLTQ8w",
  // authDomain: "radio-app-stream.firebaseapp.com",
  // databaseURL: "https://radio-app-stream.firebaseio.com",
  // projectId: "radio-app-stream",
  // storageBucket: "radio-app-stream.appspot.com",
  // messagingSenderId: "910152064891"
  apiKey: "AIzaSyCxYy6y_3ReVfXuy-i5We4KbP5sQzUFqtU",
  authDomain: "radio-sample.firebaseapp.com",
  databaseURL: "https://radio-sample.firebaseio.com",
  projectId: "radio-sample",
  storageBucket: "radio-sample.appspot.com",
  messagingSenderId: "383469780956"
};


//App setup
exports.adminConfig={
  "appName": ".radio Admin Panel",
  "slogan":"Connect with your listeners",

  "design":{
    "sidebarBg":"sidebar-1.jpg", //sidebar-1, sidebar-2, sidebar-3
    "dataActiveColor":"red", //"purple | blue | green | orange | red | rose"
    "dataBackgroundColor":"white", // "white | black"
  },

  "codeversion": "1.0",
  "allowedUsers":["admin@myradioapp.io", "demo@radioapp.io"], //If null, allow all users, else it should be array of allowd users
  "fieldBoxName": "Fields",
  "maxNumberOfTableHeaders":5,
  "prefixForJoin":["0"],
  "methodOfInsertingNewObjects":"timestamp", //timestamp (key+time) | push - use firebase keys
  "urlSeparator":"+",


  "fieldsTypes":{
    "photo":["photo","image"],
    "dateTime":["datetime","start"],
    "date":["date","created"],
    "time":["times"],
    "maps":["map","latlng"],
    "textarea":["description"],
    "html":["content", "text", "profile", "details"],
    "radio":["radio"],
    "checkbox":["checkbox"],
    "dropdowns":["status","dropdowns"],
    "file":["videos"],
    "rgbaColor":['rgba'],
    "hexColor":['color'],
    "relation":['type'],
  },
  "optionsForSelect":[
      {"key":"dropdowns","options":["new","processing","rejected","completed"]},
      {"key":"checkbox","options":["Skopje","Belgrade","New York"]},
      {"key":"status","options":["just_created","confirmed","canceled"]},
      {"key":"radio","options":["no","maybe","yes"]}
  ],
  "optionsForRelation":[
      {"key":"type","path":"/static/genres/items","value":"name","display":"name","isValuePath":false,"produceRelationKey":true,"relationKey":"type_eventid","relationJoiner":"-"},
  ],

  "paging":{
    "pageSize": 20,
    "finite": true,
    "retainLastPage": false
  }
}

//Navigation
exports.navigation=[
    {
      "link": "/",
      "name": "Dashboard",
      "schema":null,
      "icon":"code",
      isIndex:true,
      "path": "",
    },
    // {
    //   "link": "fireadmin",
    //   "path": "/",
    //   "name": "All Data",
    //   "icon":"code",
    //   "tableFields":["host","description"],
    // },
    {
      "link": "fireadmin",
      "path": "about",
      "name": "About",
      "icon":"content_copy",
      "tableFields":["title"]
    },{
      "link": "fireadmin",
      "path": "shows",
      "name": "Line Up",
      "icon":"queue_music",
      "tableFields":["name","description"],
      "subMenus": [{
        "link": "fireadmin",
        "path": "shows/mon",
        "name": "Monday",
        "icon":"settings_voice",
        "tableFields":["show","hosts","details","photo"]
      },{
        "link": "fireadmin",
        "path": "shows/tue",
        "name": "Tuesday",
        "icon":"settings_voice",
        "tableFields":["show","hosts","details","photo"]
      },{
        "link": "fireadmin",
        "path": "shows/wed",
        "name": "Wednesday",
        "icon":"settings_voice",
        "tableFields":["show","hosts","details","photo"]
      },{
        "link": "fireadmin",
        "path": "shows/thu",
        "name": "Thursday",
        "icon":"settings_voice",
        "tableFields":["show","hosts","details","photo"]
      },{
        "link": "fireadmin",
        "path": "shows/fri",
        "name": "Friday",
        "icon":"settings_voice",
        "tableFields":["show","hosts","details","photo"]
      },{
        "link": "fireadmin",
        "path": "shows/sat",
        "name": "Saturday",
        "icon":"settings_voice",
        "tableFields":["show","hosts","details","photo"]
      },{
        "link": "fireadmin",
        "path": "shows/sun",
        "name": "Sunday",
        "icon":"settings_voice",
        "tableFields":["show","hosts","details","photo"]
      }
      ]
    },{
      "link": "fireadmin",
      "path": "djs",
      "name": "Your DJ's",
      "icon":"record_voice_over",
      "tableFields":["hosts","photo","profile"],
    },{
      "link": "fireadmin",
      "path": "social",
      "name": "Social Media",
      "icon":"chat",
      "tableFields":["twitter","facebook","instagram"],
    },{
      "link": "push",
      "path": "",
      "name": "Push Notification",
      "icon":"notifications_active",
      "tableFields":[],
    }
  ];

exports.pushSettings={
  "pushType":"onesignal", //firebase or onesignal
  "Firebase_AuthorizationPushKey":"", //Firebase push authorization ket
  "pushTopic":"news", //Only for firebase push
  "oneSignal_REST_API_KEY":"",
  "oneSignal_APP_KEY":"",
  "included_segments":"Active Users", //Only for onesignal push
}

exports.userDetails={

}



// WEBPACK FOOTER //
// ./src/config/app.js